var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeZone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time-zone",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1301",
    "data-name": "Ellipse 1301",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-7 -7)",
    fill: "currentColor",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31231",
    "data-name": "Path 31231",
    d: "M7.7,0a7.69,7.69,0,0,0,0,15.38,7.773,7.773,0,0,0,5.431-2.259A7.69,7.69,0,0,0,7.7,0ZM5.416,1.3A7.638,7.638,0,0,0,4.238,3.635H2.256A6.82,6.82,0,0,1,5.416,1.3ZM1.687,4.535h2.3a13.815,13.815,0,0,0-.341,2.7H.923a6.742,6.742,0,0,1,.763-2.7ZM.923,8.14H3.649a13.809,13.809,0,0,0,.341,2.7h-2.3A6.739,6.739,0,0,1,.923,8.14Zm1.332,3.6H4.238a7.638,7.638,0,0,0,1.178,2.339A6.82,6.82,0,0,1,2.256,11.745ZM7.246,14.4c-1.01-.342-1.7-1.653-2.057-2.657H7.246Zm0-3.558H4.916a12.725,12.725,0,0,1-.366-2.7h2.7Zm0-3.6H4.55a12.725,12.725,0,0,1,.366-2.7h2.33Zm0-3.6H5.189c.36-1,1.047-2.314,2.057-2.657ZM14.47,8.14a6.76,6.76,0,0,1-1.653,4l-.63-.63-.637.637.631.631a6.761,6.761,0,0,1-4.034,1.682V8.778l1.934,1.934.637-.637L8.334,7.69,9.818,6.206l-.637-.637L8.148,6.6V.916A6.761,6.761,0,0,1,12.182,2.6l-.631.631.637.637.63-.63a6.76,6.76,0,0,1,1.653,4h-.886v.9h.886Z",
    transform: "translate(-0.008 0)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeZone);
export default __webpack_public_path__ + "static/media/time-zone.9ae51fa00721295af864c951aac2a85f.svg";
export { ForwardRef as ReactComponent };